<div class="container mt-4">
  <h4>Agent-wise Interaction Report</h4>

  <div class="row my-3">
    <div class="col-md-3">
      <label>From Date</label>
      <input type="date" [(ngModel)]="fromDate" class="form-control" />
    </div>
    <div class="col-md-3">
      <label>To Date</label>
      <input type="date" [(ngModel)]="toDate" class="form-control" />
    </div>
    <div class="col-md-3 align-self-end">
      <button class="btn btn-primary" (click)="fetchReport()">
        Generate Report
      </button>
    </div>
  </div>

  <table class="table table-bordered table-striped mt-3">
    <thead>
      <tr>
        <th>Agent Name</th>
        <th>Total Interactions</th>
        <th *ngFor="let status of getAllStatuses()">{{ status }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let report of agentReports">
        <td>{{ report.agentName }}</td>
        <td>{{ report.totalInteractions }}</td>
        <td *ngFor="let status of getAllStatuses()">
          {{ report.outcomeStatusCounts[status] || 0 }}
        </td>
      </tr>
    </tbody>
  </table>
</div>
